<p>base-picture works!</p>
